

    import {Component, Prop, Vue} from 'vue-property-decorator';
    import Branch from "../lib/Branch";

    @Component({})
    export default class NoComparisonModalMessage extends Vue {
        @Prop()
        public branch: Branch;
        public window = window;
        public home = process.env.VUE_APP_HOME;
        public doOver() {
            this.$store.commit('closeModal');
            this.$router.push({name: 'home'});
        }
        public displayHome() {
            this.$store.commit('closeModal');
            this.$router.push({name: 'home'});
        }

        mounted() {
            console.log(this.home);
        }
    }

